import {
  PHARMACY_QA_SET_FILTERS,
  PHARMACY_QA_SET_DATA,
  PHARMACY_QA_SET_SIDEBAR,
  PHARMACY_QA_SET_LOADING,
  PHARMACY_QA_SET_FILTERS_DATA,
  PHARMACY_QA_SET_FILTERS_LOADING,
  PHARMACY_QA_SET_FILTERS_SUMMARY,
  PHARMACY_QA_SET_SITES_DATA,
  PHARMACY_QA_SET_SITES_LOADING,
} from './enums/DashboardTypes';

export const initialState = {
  filters: {
    loading: false,
    data: {
      site_groups: [],
      divisions: [],
      sites: [],
      zones: [],
    },
    selected: {},
    summary: [
      {
        label: 'Selected Date',
        showValue: '',
        iconCls: 'cil-calendar',
      },
      {
        label: 'Previous Date',
        showValue: '',
        iconCls: 'cil-calendar',
      },
      {
        label: 'Drop-off SLA',
        showValue: '',
        iconCls: 'cil-clock',
      },
      {
        label: 'Collection SLA',
        showValue: '',
        iconCls: 'cil-clock',
      },
      {
        label: 'Divisions',
        iconCls: 'cil-sitemap',
        cssClass: 'w-75',
        showValue: 'All Divisions',
      },
    ],
  },
  data: {
    sites_deployed: 0,
    sites_online_array: [],
    drop_off: null,
    collection: null,
    line_chart: null,
  },
  sites: [],
  loading_sites: false,
  sidebar: false,
  loading: false,
};

const DashBoardPharmacyQueueReducer = (state = initialState, action) => {
  switch (action.type) {
    case PHARMACY_QA_SET_DATA:
      return { ...state, data: action.data };
    case PHARMACY_QA_SET_SITES_DATA:
      return { ...state, sites: action.data };
    case PHARMACY_QA_SET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, selected: action.data },
      };
    case PHARMACY_QA_SET_FILTERS_DATA:
      return { ...state, filters: { ...state.filters, data: action.data } };
    case PHARMACY_QA_SET_FILTERS_LOADING:
      return { ...state, filters: { ...state.filters, loading: action.value } };
    case PHARMACY_QA_SET_FILTERS_SUMMARY:
      return {
        ...state,
        filters: { ...state.filters, summary: action.data },
      };
    case PHARMACY_QA_SET_SIDEBAR:
      return { ...state, sidebar: !state.sidebar };
    case PHARMACY_QA_SET_LOADING:
      return { ...state, loading: action.value };
    case PHARMACY_QA_SET_SITES_LOADING:
      return { ...state, loading_sites: action.value };
    default:
      return state;
  }
};
export default DashBoardPharmacyQueueReducer;
